import React from 'react'
import { Container, Text } from './styles'
import { Button } from '../Button'
import { IconComponent } from '~/assets/icons/component'
import { message } from '~/services'

import { IDataNotFoundProps } from '~/interfaces'

export const DataNotFound = ({ text, onRefresh }: IDataNotFoundProps): JSX.Element => {
  return (
    <Container>
      <IconComponent name="dataNotFound" />
      <Text>{text}</Text>
      {onRefresh && (
        <Button variant="outlined" onClick={onRefresh}>
          {message('timeline.refresh_button')}
        </Button>
      )}
    </Container>
  )
}
